import React from 'react';
import axios from "../../../../containers/api";
import {toEnglishNumbers} from "../../../../helpers/Utils";
import {Button, CardBody, Input, Row, FormGroup, Label, CustomInput} from "reactstrap";
import {Colxx} from "../../../../components/common/CustomBootstrap";

class AgentSalonFinancialConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maliSalonToEdit: this.props.OneAgent
        }

        console.log(this.state.maliSalonToEdit)
    }

    configSalonFinance() {
        if (this.state.maliSalonToEdit.agentId === null || this.state.maliSalonToEdit.agentId === '') {
            this.props.showAlert('سالنی انتخاب نشده است', 'error');
            return;
        }
        if ((this.state.maliSalonToEdit.isMonyKilometer === false || this.state.maliSalonToEdit.isMonyKilometer === null) && (this.state.maliSalonToEdit.reserveMony === null || this.state.maliSalonToEdit.reserveMony === '')) {
            this.props.showAlert('مبلغ رزرو را وارد کنید', 'error');
            return;
        }
        if (this.state.maliSalonToEdit.isMonyKilometer === true && (this.state.maliSalonToEdit.maxKilometerPrice === null || this.state.maliSalonToEdit.maxKilometerPrice === '')) {
            this.props.showAlert(' مبلغ هر کیلومتر را وارد کنید', 'error');
            return;
        }
        if (this.state.maliSalonToEdit.isMonyKilometer === true && (this.state.maliSalonToEdit.minKilometerPrice === null || this.state.maliSalonToEdit.minKilometerPrice === '')) {
            this.props.showAlert('حداقل مبلغ رزرو را وارد کنید', 'error');
            return;
        }
        if (this.state.maliSalonToEdit.isMonyKilometer === true && (this.state.maliSalonToEdit.minReserveKilometr === null || this.state.maliSalonToEdit.minReserveKilometr === '')) {
            this.props.showAlert('حداقل کیلومتر رزرو را وارد کنید', 'error');
            return;
        }

        let model = {
            AgentId: this.state.maliSalonToEdit.agentID,
            ReserveMony: this.state.maliSalonToEdit.ReserveMony,
            IsMonyKilometer: this.state.maliSalonToEdit.isMonyKilometer,
            MaxKilometerPrice: this.state.maliSalonToEdit.maxKilometerPrice,
            MinKilometerPrice: this.state.maliSalonToEdit.minKilometerPrice,
            MinReserveKilometr: this.state.maliSalonToEdit.minReserveKilometr
        };

        this.props.showSpinner();
        axios.post('api/AgencyApi/AgentFinancialConfiguration', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert("تنظیمات با موفقیت ثبت شد", "success");
                this.props.closeModal("showFinancialConfigSalonModal");
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response)
            });
    }

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-20 w-100 px-1">
                                <CustomInput
                                    type="checkbox"
                                    id="isMonyKilometer"
                                    name="isMonyKilometer"
                                    label="مبلغ بر اساس کیلومتر"
                                    checked={this.state.maliSalonToEdit.isMonyKilometer}
                                    onClick={(e) => this.setState({
                                        maliSalonToEdit: {
                                            ...this.state.maliSalonToEdit,
                                            isMonyKilometer: !this.state.maliSalonToEdit.isMonyKilometer,
                                            reserveMony: null,
                                            maxKilometerPrice: null,
                                            minKilometerPrice: null,
                                            minReserveKilometr: null,
                                        }
                                    })}
                                />
                            </FormGroup>
                        </div>

                        {(this.state.maliSalonToEdit.isMonyKilometer === false || this.state.maliSalonToEdit.isMonyKilometer === null ) ?
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>مبلغ رزرو</Label>
                                    <Input value={this.state.maliSalonToEdit.reserveMony} placeholder="سهم سالن" maxLength={20}
                                           onChange={(e) => this.setState({maliSalonToEdit: {...this.state.maliSalonToEdit, reserveMony: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, ""))}})}/>
                                </FormGroup>
                            </div>
                            :
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>مبلغ هر کیلومتر</Label>
                                    <Input value={this.state.maliSalonToEdit.maxKilometerPrice} placeholder="ریال" maxLength={20}
                                           onChange={(e) => this.setState({maliSalonToEdit: {...this.state.maliSalonToEdit, maxKilometerPrice: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, ""))}})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>حداقل مبلغ رزرو</Label>
                                    <Input value={this.state.maliSalonToEdit.minKilometerPrice} placeholder="ریال" maxLength={20}
                                           onChange={(e) => this.setState({maliSalonToEdit: {...this.state.maliSalonToEdit, minKilometerPrice: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, ""))}})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>حداقل کیلومتر</Label>
                                    <Input value={this.state.maliSalonToEdit.minReserveKilometr} placeholder="کیلومتر" maxLength={20}
                                           onChange={(e) => this.setState({maliSalonToEdit: {...this.state.maliSalonToEdit, minReserveKilometr: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, ""))}})}/>
                                </FormGroup>
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2"
                                        onClick={() => this.configSalonFinance()}>
                                    ذخیره تنظیمات
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AgentSalonFinancialConfig;